import React, { useState, useEffect } from 'react';
import { Table, Typography, Tooltip, Button, Row, Col, Menu, message, Spin, Modal, Card, Breadcrumb, Popconfirm, List, Upload, Divider } from 'antd';
import { BASE_URL,DateFormat,DateTimeFormat } from '../Components/Constant';
import ApiService from '../Components/apiService';
import { DeleteOutlined, EditOutlined, IssuesCloseOutlined } from '@ant-design/icons';
import ReportEditor from './ReportEditor';
import Cookies from 'js-cookie';
import DisplayReport from './ReportDisplay';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import {convertDateToUserTimezone} from '../Components/Utility';
import ReportBuilder from './ReportBuilder';

const CreateReports = () => {
    const { Title } = Typography;

    const [allReports, setAllReports] = useState([]);
    const [showReportEditor,setShowReportEditor]=useState(false);
    const [selectedReport,setSelectedReport]=useState(null);
    const [loading,setLoading]=useState(true);
    const currentUserId = Cookies.get('userId');
    const navigate = useNavigate();
    const security = useSelector((state) => state.data.items[0]);
    const [pageSize, setPageSize] = useState(10);

    useEffect(()=>{
        fetchAllReports(); 
    },[currentUserId]);

    const fetchAllReports = async () => {
        try {
            setLoading(true);
            const apiService = new ApiService(
                `${BASE_URL}/mt_reports`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const response = await apiService.makeCall(navigate);
            setAllReports(response);


        }
        catch (error) {

        }finally{
            setLoading(false);
        }
    }

    const handleEditReport = (report) => {
        if(security?.system_settings?.report.edit===false){
            message.error('You dont have permission to edit ');
            return;
          }
        setSelectedReport(report)
        setShowReportEditor(true);
    }


    const showDisplayReport=(id)=>{
        if(security?.system_settings?.report.view===false){
            message.error('You dont have permission to view ');
            return;
          }
        navigate(`/ViewReport/${id}`);
    
    }


    const deleteReport = async (report) => {
        if(security?.system_settings?.report.delete===false){
            message.error('You dont have permission to delete ');
            return;
          }
        try {
            setLoading(true);
            const apiService = new ApiService(
                `${BASE_URL}/reports/${report._id}`,
                { 'Content-Type': 'application/json' },
                'DELETE',
            );

            const response = await apiService.makeCall();
            fetchAllReports();
            message.success('Report deleted successfully');
        } catch (error) {
            message.error('Failed to delete report');
        }
        finally{
            setLoading(false);

        }
    }



    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            sorter: (a, b) => a.name.localeCompare(b.name),
            render: (text,report) => (
                <span
                  onClick={() => showDisplayReport(report._id)}
                  style={{ color: '#0070d2', cursor: 'pointer' }}
                >
                {text}
                  
                </span>
              ),
        },
        {
            title: "Model",
            dataIndex: "model",
            key: "model",
            sorter: (a, b) => a.model.localeCompare(b.model),
        },
        {
            title: "Aggregation Fields",
            dataIndex: "aggregation_fields",
            key: "aggregation_fields",
            render: (fields) => fields?.join(", "), // To display array values as a comma-separated string
        },
        {
            title: "Group Fields",
            dataIndex: "group_fields",
            key: "group_fields",
            render: (fields) => fields?.join(", "), // To display array values as a comma-separated string
        },
        {
            title: "Chart Type",
            dataIndex: "chart_type",
            key: "chart_type",
            sorter: (a, b) => a.chart_type.localeCompare(b.chart_type),
        },
       
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
        },
       
        
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: 'created_at',
            // width: 100,
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
            render: (text) => (
                text && dayjs(text).isValid()
                  ? convertDateToUserTimezone(text, DateTimeFormat)
                  : ''
              ),
                    
          },
          {
            title: 'Updated At',
            dataIndex: 'updated_at',
            key: 'updated_at',
            // width: 100,
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
            render: (text) => (
                text && dayjs(text).isValid()
                  ? convertDateToUserTimezone(text, DateTimeFormat)
                  : ''
              ),
                    
          },
       
    ];
    

    columns.push({
        title: 'Action',
        key: 'operation',
        render: (_, report) => (
            <>
                <Tooltip title="Edit">
                    <EditOutlined
                        onClick={() => handleEditReport(report)}
                        style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
                    />
                </Tooltip>


                <Tooltip title="Delete">
                    <Popconfirm
                        title="Are you sure you want to delete this item?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => deleteReport(report)}


                    >
                        <DeleteOutlined style={{ color: 'red', marginRight: 5, fontSize: '12px', cursor: 'pointer' }} />
                    </Popconfirm>
                </Tooltip>
            </>
        ),
    });

   

    return (

        <Card>
            {!showReportEditor ? (
                <>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: '16px' }}>
                    <Col>
                        <Title level={3} style={{ margin: 0 }}>All Reports</Title>
                    </Col>
                    <Col>
                        <Button type="primary" onClick={()=>{
                             if(security?.system_settings?.report.create===false){
                                message.error('You dont have permission to create ');
                                return;
                              }
                            setSelectedReport(null);
                            navigate('/setup/ReportBuilder');

                        }}>Create Report</Button>
                    </Col>
                </Row>
            </div>


            <Spin size="small" spinning={loading}>
            <Table
                dataSource={allReports}
                columns={columns}
                rowKey="_id"
                scroll={{ y: 550 }}
                pagination={{
                    pageSize: pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50', '100'],
                    onChange: (page, pageSize) => {
                        setPageSize(pageSize);
                    },              
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                }}
            />
            </Spin>

            </>

        ) : (
            // <ReportEditor
               
            //     onBack={() => setShowReportEditor(false)}
            //     fetchAllReports={fetchAllReports}
            //     selectedReport={selectedReport}
            // />
            <ReportBuilder 
                fetchAllReports={fetchAllReports}
                onBack={() => {
                    setShowReportEditor(false)
                    setSelectedReport(null)
                }
                }
                selectedReportForEdit={selectedReport}
            />
        )}
        </Card>
    );

}

export default CreateReports;